var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c("w-col", { attrs: { xs: "12" } }, [
        _c(
          "div",
          [
            _vm._l(_vm.highlight.Conditions, function (condition, i) {
              return _c(
                "w-chip",
                {
                  key: condition.key,
                  attrs: {
                    closable: "",
                    clickable: "",
                    active: i == _vm.selectedConditionIndex,
                  },
                  on: {
                    click: function ($event) {
                      _vm.selectedConditionIndex = i
                    },
                    close: function ($event) {
                      return _vm.removeCondition(i)
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.getConditionAsString(condition)) + " "
                  ),
                ]
              )
            }),
            _c(
              "w-button",
              {
                attrs: { round: "", sm: "" },
                on: {
                  click: function ($event) {
                    return _vm.addCondition()
                  },
                },
              },
              [_c("w-fa", { attrs: { icon: "plus" } })],
              1
            ),
          ],
          2
        ),
      ]),
      _c(
        "w-col",
        { attrs: { xs: "12", "no-margin": "" } },
        [
          _vm.selectedCondition
            ? _c("app-browse-condition-edit", {
                attrs: {
                  browse: _vm.browse,
                  model: _vm.model,
                  "allow-computed-fields": "",
                },
                model: {
                  value: _vm.selectedCondition,
                  callback: function ($$v) {
                    _vm.selectedCondition = $$v
                  },
                  expression: "selectedCondition",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }